import * as prismic from '@prismicio/client';
import * as prismicNext from '@prismicio/next';

export const repositoryName = 'onepac';

// Kept in sync with the Next.js route segments (and with prismic.config.json)
// so the Prismic preview button (redirectToPreviewURL) lands on the right page.
const routes: prismic.ClientConfig['routes'] = [
  // Home + singleton content pages
  { type: 'home', path: '/:lang?' },
  { type: 'about', path: '/:lang?/about' },
  { type: 'consulting', path: '/:lang?/consulting' },
  { type: 'implementations', path: '/:lang?/implementations' },
  { type: 'managed_services', path: '/:lang?/managed-services' },
  { type: 'partner_support', path: '/:lang?/partner-support' },
  { type: 'netsuite_rescue', path: '/:lang?/netsuite-rescue' },
  { type: 'pricing_calculator', path: '/:lang?/netsuite-price' },
  { type: 'health_check', path: '/:lang?/health-check' },
  { type: 'contact', path: '/:lang?/contact' },
  { type: 'privacy', path: '/:lang?/privacy' },
  { type: 'terms', path: '/:lang?/terms' },
  { type: 'faq_archive', path: '/:lang?/faq' },
  // Listing pages (one single-type doc per listing)
  { type: 'blogs', path: '/:lang?/blog' },
  { type: 'integrations', path: '/:lang?/integrations' },
  { type: 'industries', path: '/:lang?/industries' },
  { type: 'success_stories', path: '/:lang?/success' },
  { type: 'videos', path: '/:lang?/videos' },
  // Repeatable detail pages
  { type: 'blog', path: '/:lang?/blog/:uid' },
  { type: 'long_article', path: '/:lang?/guides/:uid' },
  { type: 'integration', path: '/:lang?/integrations/:uid' },
  { type: 'industry', path: '/:lang?/industries/:uid' },
  { type: 'success_story', path: '/:lang?/success/:uid' },
  { type: 'video', path: '/:lang?/videos/:uid' },
];

/**
 * Creates a Prismic client for the project's repository. The client is used to
 * query content from the Prismic API.
 *
 * @param config - Configuration for the Prismic client.
 */
export const createClient = (config: prismicNext.CreateClientConfig = {}) => {
  const client = prismic.createClient(repositoryName, {
    routes,
    fetchOptions:
      process.env.NODE_ENV === 'production'
        ? { next: { tags: ['prismic'] }, cache: 'force-cache' }
        : { next: { revalidate: 0 }, cache: 'no-store' },
    ...config,
  });

  prismicNext.enableAutoPreviews({ client });

  return client;
};
